(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kct-cart"]) return;
  try {
    
document.querySelectorAll('[data-wholesale-cart]').forEach(root=>{root.querySelectorAll('[name="updates[]"]').forEach(input=>input.addEventListener('input',()=>{root.querySelector('[name="checkout"]').disabled=true;root.querySelector('[data-cart-dirty]').hidden=false;}));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kct-product-detail"]) return;
  try {
    
function initKctPdp(root){
if(root.dataset.ready)return;
const select=root.querySelector('[data-pdp-variant]');if(!select)return;
const labels=root.querySelector('[data-pdp-labels]').dataset;
const variants=[...select.options].map(o=>({id:o.value,options:JSON.parse(o.dataset.options),available:o.dataset.available==='true',price:o.dataset.price,media:o.dataset.mediaId}));
const radios=[...root.querySelectorAll('[data-pdp-option]')];
function showMedia(id){const slides=[...root.querySelectorAll('[data-media]')];if(!slides.some(s=>s.dataset.media===id))return;slides.forEach(s=>s.hidden=s.dataset.media!==id);root.querySelectorAll('[data-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.thumb===id)));}
function sync(v){select.value=v?v.id:'';root.querySelectorAll('[data-pdp-buy]').forEach(b=>{b.disabled=!v||!v.available;b.textContent=v&&v.available?labels.add:labels.unavailable});root.querySelectorAll('[data-pdp-price]').forEach(p=>p.textContent=v?v.price:'—');root.querySelector('[data-pdp-status]').textContent=v&&v.available?labels.available:labels.unavailable;if(v){const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);if(v.media)showMedia(v.media);}}
const initial=variants.find(v=>v.id===select.value);radios.forEach(r=>{r.checked=Boolean(initial&&initial.options[Number(r.dataset.pdpOption)]===r.value);if(r.checked)root.querySelector('[data-option-label="'+r.dataset.pdpOption+'"]').textContent=r.value;r.addEventListener('change',()=>{const values=[];radios.filter(x=>x.checked).forEach(x=>{values[Number(x.dataset.pdpOption)]=x.value;root.querySelector('[data-option-label="'+x.dataset.pdpOption+'"]').textContent=x.value});sync(variants.find(v=>v.options.every((value,i)=>value===values[i])));});});
root.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.thumb)));
const first=root.querySelector('[data-media]');if(first)showMedia(initial&&initial.media||first.dataset.media);
root.querySelectorAll('[data-quantity-step]').forEach(b=>b.addEventListener('click',()=>{const q=root.querySelector('[name="quantity"]');q.value=Math.max(1,(parseInt(q.value,10)||1)+Number(b.dataset.quantityStep));q.dispatchEvent(new Event('change',{bubbles:true}));}));
root.classList.add('pdp-enhanced');root.dataset.ready='true';
}
document.querySelectorAll('[data-kct-pdp]').forEach(initKctPdp);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-kct-pdp]').forEach(initKctPdp));

  } catch(e) { console.error(e); }
})();
})();
